import { ScanTree } from "../cluetheory/scans/ScanTree";
import { util } from "../../lib/util/util";
import { FakeLodash } from "../../lib/coreutil/FakeLodash";
export var SolvingMethods;
(function (SolvingMethods) {
    var timestamp = util.timestamp;
    var uuid = util.uuid;
    let ClueAssumptions;
    (function (ClueAssumptions) {
        function init() {
            return {
                double_escape: true,
                double_surge: true,
                full_globetrotter: true,
                meerkats_active: true,
                mobile_perk: true,
                way_of_the_footshaped_key: true
            };
        }
        ClueAssumptions.init = init;
        function filterWithRelevance(assumptions, relevance) {
            const copy = FakeLodash.cloneDeep(assumptions);
            for (let key of Object.keys(copy)) {
                if (!relevance.includes(key))
                    copy[key] = undefined;
            }
            return copy;
        }
        ClueAssumptions.filterWithRelevance = filterWithRelevance;
        let Relevance;
        (function (Relevance) {
            Relevance.path = ["double_escape", "double_surge", "mobile_perk", "range_weapon_range"];
            Relevance.all = [...Relevance.path, "way_of_the_footshaped_key", "full_globetrotter", "meerkats_active"];
            function forSpot(step) {
                const relevant = [...Relevance.path];
                if (step.clue.solution && step.clue.solution.type == "search" && step.clue.solution.key) {
                    relevant.push("way_of_the_footshaped_key");
                }
                if (step.clue.type == "emote" && step.clue.hidey_hole) {
                    relevant.push("full_globetrotter");
                }
                if (step.clue.type == "scan") {
                    relevant.push("meerkats_active");
                }
                return relevant;
            }
            Relevance.forSpot = forSpot;
        })(Relevance = ClueAssumptions.Relevance || (ClueAssumptions.Relevance = {}));
    })(ClueAssumptions = SolvingMethods.ClueAssumptions || (SolvingMethods.ClueAssumptions = {}));
    let Method;
    (function (Method) {
        function meta(method) {
            return {
                name: method.name,
                description: method.description,
                assumptions: method.assumptions
            };
        }
        Method.meta = meta;
        function setMeta(method, meta) {
            method.name = meta.name;
            method.description = meta.description;
            method.assumptions = FakeLodash.cloneDeep(meta.assumptions);
            return method;
        }
        Method.setMeta = setMeta;
        function allPaths(method) {
            const raw = (() => {
                switch (method.type) {
                    case "general_path":
                        return [method.pre_path, method.main_path, method.post_path];
                    case "scantree":
                        function gather(accu, node) {
                            accu.push(node.path);
                            node.children.forEach(c => gather(accu, c.value));
                            return accu;
                        }
                        return gather([], method.tree.root);
                }
            })();
            raw.filter(p => p && p.length > 0);
            return raw.flat();
        }
        Method.allPaths = allPaths;
    })(Method = SolvingMethods.Method || (SolvingMethods.Method = {}));
    function init(clue) {
        // TODO: Sensible default names
        if (clue.clue.type == "scan") {
            return {
                id: uuid(),
                type: "scantree",
                timestamp: timestamp(),
                name: "",
                description: "",
                assumptions: ClueAssumptions.init(),
                for: { clue: clue.clue.id },
                tree: ScanTree.init(clue.clue)
            };
        }
        else {
            return {
                id: uuid(),
                type: "general_path",
                timestamp: timestamp(),
                name: "",
                description: "",
                assumptions: ClueAssumptions.init(),
                for: { clue: clue.clue.id, spot: clue.spot ?? undefined },
                post_path: [],
                pre_path: [],
                main_path: [],
            };
        }
    }
    SolvingMethods.init = init;
    function clone(method) {
        const clone = FakeLodash.cloneDeep(method);
        clone.id = uuid();
        return clone;
    }
    SolvingMethods.clone = clone;
})(SolvingMethods || (SolvingMethods = {}));
